const Link2Off = [
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": 2,
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  },
  [
    ["path", { d: "M15 7h2a5 5 0 0 1 4 8M9 17H7A5 5 0 0 1 7 7" }],
    ["line", { x1: "8", y1: "12", x2: "12", y2: "12" }],
    ["line", { x1: "2", y1: "2", x2: "22", y2: "22" }]
  ]
];

export default Link2Off;
